import { render, staticRenderFns } from "./shipping-rate.vue?vue&type=template&id=6c48ba82&"
import script from "./shipping-rate.vue?vue&type=script&lang=js&"
export * from "./shipping-rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports